import React, { useEffect, useState } from "react";
// import Header from "../../components/header/Header.tsx";
// import Navbar from "../../components/navbar/Navbar.tsx";
// import Footer from "../../components/footer/Footer.tsx";
import { useLocation } from "react-router-dom";
import { getFetcher, postFetcher } from "../../../api/fetchers.ts";
import { endpoints } from "../../../api/endpoints.ts";
import { ToastContainer } from "react-toastify";
import ProductCart from "../../components/ProductCart.tsx";
import { useLanguage } from "../../context/LanguageContext.tsx";
import { IoMdWarning } from "react-icons/io";
import { useUser } from "../../context/UserContext.tsx";

interface LocationState {
  mainId: string;
  complain: any;
  mainTitle: string;
}

const ComplainDetail = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const { user } = useUser();
  const { complain, mainTitle } = (location.state as LocationState) || {};

  const queryParams = new URLSearchParams(location.search);
  const id: any = queryParams.get("id");
  const index: any = queryParams.get("index");

  const [ids, setIds] = useState<number[]>([]);
  const [products, setProducts]: any = React.useState([]);
  const [userBusinessPackage, setUserBusinessPackage] = useState<any>();

  const nameIds = () => {
    if (id == 1) {
      if (index == 0) {
        setIds([33]); //Karın Duvarı Fıtığı
      } else if (index == 1) {
        setIds([79]); //Kaburga Kırıkları ve Yaralanmalar
      } else if (index == 2) {
        setIds([47]); //Pulmoner Emboli (Akciğerlerde Kan Pıhtılaşması)
      } else if (index == 3) {
        setIds([]); // Kalp Yetmezliği
      } else if (index == 4) {
        setIds([47, 82]); // Koroner Arter Hastalığı
      }
    } else if (id == 2) {
      if (index == 0) {
        setIds([49, 43]); //Başparmak – Ameliyat veya Travma Sonrası Rehabilitasyon
      } else if (index == 1) {
        setIds([84, 49, 43]); //Başparmak Tabanı Osteoartriti
      } else if (index == 2) {
        setIds([49, 43]); //Kırık Başparmak
      } else if (index == 3) {
        setIds([49, 43]); //RSI Başparmak
      } else if (index == 4) {
        setIds([72, 38, 37]); //Rower's Wrist (Dümencinin Bileği)
      } else if (index == 5) {
        setIds([48]); //Kubital Tünel Sendromu ve Tedavi Yöntemleri
      } else if (index == 6) {
        setIds([36, 85, 48]); //Dirsek Kırığı ve Rehabilitasyonu
      } else if (index == 7) {
        setIds([85]); //Dirsek Osteoartriti ve Tedavi Yöntemleri
      } else if (index == 8) {
        setIds([85, 36]); //Golfçü Dirseği ve Tedavi Yöntemleri
      }
    } else if (id == 3) {
      if (index == 0) {
        setIds([82]); //Sırt Ağrısında Osteoartrit
      } else if (index == 1) {
        setIds([82, 83]); //Kronik Sırt Ağrısı
      } else if (index == 2) {
        setIds([82]); //Sırt veya Belde Aşırı Esneme (Hyperextension)
      } else if (index == 3) {
        setIds([76, 82]); //Sırt Yaralanması
      } else if (index == 4) {
        setIds([82, 67]); //Spondilolizis
      } else if (index == 5) {
        setIds([67]); //Löw Bel Ağrısı
      } else if (index == 6) {
        setIds([81, 82]); //Postür Bozukluğu
      } else if (index == 7) {
        setIds([81, 47]); //Bel Fıtığı
      }
    } else if (id == 4) {
      if (index == 0) {
        setIds([50, 51]); //Bacakta Tromboz – Sebepleri, Belirtileri ve Tedavi Yöntemleri
      } else if (index == 1) {
        setIds([22]); //Varisli Damarlar – Sebepleri, Belirtileri ve Tedavi Yöntemleri
      } else if (index == 2) {
        setIds([44]); //Yırtık Baldır Kasının Tedavi Yöntemleri ve İyileşme Süreci
      } else if (index == 3) {
        setIds([41]); //Geçici Topallama – Sebepleri, Belirtileri ve Tedavi Yöntemleri
      } else if (index == 4) {
        setIds([75, 44]); //Whiplash (Baldır Kası Yırtığı) Tedavi Yöntemleri
      } else if (index == 5) {
        setIds([51, 75, 44]); //Shin Splints (Baldır Ağrıları) Tedavi Yöntemleri
      } else if (index == 6) {
        setIds([44, 75]); //Baldır Ağrısı Tedavi Yöntemleri
      }
    } else if (id == 5) {
      if (index == 0) {
        setIds([86]); //Yanma Hissi Olan Ayaklar ve Tedavi Yöntemleri
      } else if (index == 1) {
        setIds([86, 74]); //Plantar Fasiit ve Tedavi Yöntemleri
      } else if (index == 2) {
        setIds([86, 52]); //Morton's Nöraljisi ve Tedavi Yöntemleri
      } else if (index == 3) {
        setIds([54, 53]); //Metatarsalji ve Tedavi Yöntemleri
      } else if (index == 4) {
        setIds([54, 53, 41, 87]); //Topuk Dikeni ve Tedavi Yöntemleri
      } else if (index == 5) {
        setIds([40, 73]); //Baker Kisti ve Tedavi Seçenekleri
      } else if (index == 6) {
        setIds([40]); //Diz Yaralanması ve Tedavi Yöntemleri
      } else if (index == 7) {
        setIds([40, 51, 73]); //Diz Bağ Yırtığı
      }
    } else if (id == 6) {
      if (index == 0) {
        setIds([81]); //Omuz Osteoartriti ve Tedavi Yöntemleri
      } else if (index == 1) {
        setIds([48, 70, 71]); //Kübital Tünel Sendromu ve Tedavi Yöntemleri
      } else if (index == 2) {
        setIds([36, 48, 71]); //Dirsek Bursiti ve Tedavi Yöntemleri
      } else if (index == 3) {
        setIds([81, 70]); //Omuz Çıkığı ve Tedavi Yöntemleri
      } else if (index == 4) {
        setIds([81]); //Donmuş Omuz ve Tedavi Yöntemleri
      } else if (index == 5) {
        setIds([48, 71, 36]); //Dirsek Kırığı ve Tedavi Yöntemleri
      } else if (index == 6) {
        setIds([71, 48, 36]); //Dirsek - Hiperekstansiyon Capsüler Tuzaklanması (İmpinjman Sendromu)
      } else if (index == 7) {
        setIds([81, 70]); //Omuzdaki Romatizma ve Tedavi Yöntemleri
      }
    } else if (id == 7) {
      if (index == 0) {
        setIds([50, 79]); //Kalça Osteoartriti
      } else if (index == 1) {
        setIds([50, 79]); //Pelvik Instabilite
      } else if (index == 2) {
        setIds([50]); //Bruised Hip
      } else if (index == 3) {
        setIds([50, 29]); //Iliopsoas Sendromu
      } else if (index == 4) {
        setIds([50, 29, 79]); //Pelvik Instabilite
      } else if (index == 5) {
        setIds([82, 50, 47]); //Ankilozan Spondilit
      }
    } else if (id == 8) {
      if (index == 0) {
        setIds([85, 38, 37, 84, 72]); //Rower's Wrist (Dümencinin Bileği)
      } else if (index == 1) {
        setIds([85, 38, 37, 84, 72]); //RSI (Tekrarlayan Zorlama Yaralanması)
      } else if (index == 2) {
        setIds([37]); //Skafod Kırığı (Scaphoid Fracture)
      } else if (index == 3) {
        setIds([38]); //Bilek Romatizması
      } else if (index == 4) {
        setIds([37, 38, 84]); //Düzensiz Bilek
      } else if (index == 5) {
        setIds([84]); //Fare Kolu
      } else if (index == 6) {
        setIds([37, 84, 38, 85]); //Bilek Tendiniti
      }
    } else if (id == 9) {
      if (index == 0) {
        setIds([80]); //Boyun Artrozu (Osteoartrit)
      } else if (index == 1) {
        setIds([31, 80, 69]); //Boyun - Diskopati Servikal Omurga Problemleri
      } else if (index == 2) {
        setIds([80, 31, 66]); //Boyun Fıtığı
      } else if (index == 3) {
        setIds([80]); //Whiplash Şikayetleri
      } else if (index == 4) {
        setIds([31]); //Tortikolis
      }
    }
  };

  useEffect(() => {
    nameIds();
  }, [index, id]);

  const getProductCategory = async () => {
    try {
      let allProducts: any[] = [];

      if (ids.length === 0) {
        console.warn("IDs array is empty, no API call made.");
        return;
      }
      for (const subCatId of ids) {
        const response = await postFetcher(
          endpoints.products.productsSubCategoryId,
          {
            arg: {
              subCategoryId: subCatId,
              pageNumber: 0,
            },
          }
        );

        if (response.result && response.products) {
          allProducts = [...allProducts, ...response.products];
        }
      }

      setProducts(allProducts);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    if (ids.length > 0) {
      getProductCategory();
    }
  }, [ids]);

  const fetchBusinessPackageData = async () => {
    if (user) {
      try {
        const businessPackage = await getFetcher(
          endpoints.user.getBusinessPackageById.replace(
            "{id}",
            user.businessPackageId
          )
        );
        if (businessPackage.result) {
          setUserBusinessPackage(businessPackage.businessPackage);
        }
      } catch (error) {
        console.error("Error fetching business package:", error);
      } finally {
        console.log("first");
      }
    } else {
      console.log("err");
    }
  };

  useEffect(() => {
    fetchBusinessPackageData();
  }, [user]);

  return (
    <div className="flex flex-col min-h-[80rem]">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* <Header />
      <div className={` top-0 left-0 w-full z-30`}>
        <Navbar />
      </div> */}

      <div className="mt-4 md:mt-0 md:flex mx-auto md:justify-between w-[92%]">
        <div className="md:w-[30%] py-4 px-4 bg-[#F8F9F9] rounded-lg border-b-[#EFC93D] border-2">
          <p className="font-bold mb-2 text-[#03363D]">
            {t("complainDetail", "title")}
          </p>
          <p className="text-sm text-[#17494D]">
            {t("complainDetail", "subTitle")}
          </p>
        </div>

        <div className="mt-4 md:mt-0 md:w-[30%] py-4 px-4 bg-[#F8F9F9] rounded-lg border-b-[#3D8DAE] border-2">
          <p className="font-bold mb-2 text-[#03363D]">
            {t("complainDetail", "title2")}
          </p>
          <p className="text-sm text-[#17494D]">
            {t("complainDetail", "subTitle2")}
          </p>
        </div>

        <div className="mt-4 md:mt-0 md:w-[30%] py-4 px-4 bg-[#F8F9F9] rounded-lg border-b-[#AF2C2C] border-2">
          <p className="font-bold mb-2 text-[#03363D]">
            {t("complainDetail", "title3")}
          </p>
          <p className="text-sm text-[#17494D]">
            {t("complainDetail", "subTitle3")}
          </p>
        </div>
      </div>

      <div className="mt-10">
        <div className=" mx-auto md:w-[30%] py-4 px-4 bg-red-200 rounded-lg border-b-red-600 border-2 flex flex-col justify-center items-center gap-y-1">
          <IoMdWarning className=" text-yellow-400 -mt-3" size={50} />
          <p className=" text-sm text-[#17494D] text-center">
            {t("complainDetail", "warn")}
            <br />
            <a className="font-bold" href="mailto:expert@novamedshop.com">
              expert@novamedshop.com
            </a>
          </p>
        </div>
      </div>

      <div className="md:flex mx-auto md:justify-between w-[92%] mt-8 md:mt-14">
        <div className="md:w-[42%]">
          <p className="text-md font-bold text-[#03363D] ml-4">{mainTitle}</p>
          <p className="text-5xl font-semibold text-[#FFC633] mt-4">
            {complain?.title}
          </p>
          {complain?.description && (
            <p className=" mt-3">{complain?.description}</p>
          )}
        </div>

        <div className="md:w-[46%]">
          <p className="text-2xl font-semibold text-[#FFC633] mt-4 md:text-end">
            {complain?.firstQuestion}
          </p>
          <p className="text-md text-[#03363D] mt-1 md:text-end">
            {complain?.firstAnswer}
          </p>
        </div>
      </div>

      <div className="md:flex mx-auto md:justify-between w-[92%] mt-10 items-center">
        <div className="md:w-[46%]">
          <p className="text-2xl font-semibold text-[#FFC633] mt-4">
            {complain?.secondQuestion}
          </p>
          <p className="text-md text-[#03363D] mt-1 ">
            {complain?.secondAnswer}
          </p>
        </div>

        <img
          src={complain?.images[0]}
          className="w-[400px] h-[400px] object-contain"
        ></img>
      </div>

      <div className="md:flex mx-auto md:justify-between w-[92%] mt-10">
        <div className="md:w-[46%]">
          <p className="text-2xl font-semibold text-[#FFC633] mt-4">
            {complain?.thirdQuestion}
          </p>
          <p className="text-md text-[#03363D] mt-1 ">
            {complain?.thirdAnswer}
          </p>
        </div>

        <div className="md:w-[46%]">
          <p className="text-2xl font-semibold text-[#FFC633] mt-4 md:text-end">
            {complain?.fourthQuestion}
          </p>
          <p className="text-md text-[#03363D] mt-1 md:text-end">
            {complain?.fourthAnswer}
          </p>
        </div>
      </div>

      <div className="md:flex mx-auto md:justify-between w-[92%] mt-10">
        <div className="w-full">
          <p className="text-2xl font-semibold text-[#FFC633] mt-4">
            {complain?.fifthQuestion}
          </p>
          <p className="text-md text-[#03363D] mt-1 ">
            {complain?.fifthAnswer}
          </p>
        </div>
      </div>

      <div className="w-11/12 mx-auto mt-8">
        <p className="text-3xl font-bold mb-8 flex justify-center text-[#03363D]">
          {t("complain", "oneri1")}{" "}
          <a className="ml-2 text-[#FFC633]">{t("complain", "oneri2")}</a>
        </p>

        {products?.length < 1 ? (
          <p className="flex justify-center text-[#03363D] my-5">
            {t("complain", "noOneri")}
          </p>
        ) : (
          <div className="grid my-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-14 mt-2 justify-items-center">
            {products?.map((item: any, index: number) => {
              return (
                <ProductCart
                  product={item}
                  key={index}
                  userBusinessPackage={userBusinessPackage}
                />
              );
            })}
          </div>
        )}
      </div>

      {/* <Footer /> */}
    </div>
  );
};

export default ComplainDetail;
